import { createSlice } from "@reduxjs/toolkit"
import { initialState } from './../../initialState';


  
  export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
      getRoles: (state,action) => {
        state.roles = action.payload
      },
      openSidebar: (state) => {
        state.sidebarToggle = !state.sidebarToggle
      },
      closeSidebar: (state) => {
        state.sidebarToggle = false
      },
      darkMode: (state) => {
        state.dark = !state.dark
      },
      openApprovalModal:(state,action) => {
        state.approvalModal = action.payload
      },
      approvalModalLoading:(state) => {
        state.approvalModal.loading = true
      },
      closeApprovalModal: (state) => {
        state.approvalModal = {open:false,content:''}
      },
      openInlineApprovalModal:(state,action) => {
        state.invoiceInlineApprovalModal = action.payload
      },
      closeInlineApprovalModal:(state) => {
        state.invoiceInlineApprovalModal = {open:false,invoiceStatusId:null,text:''}
      },
      openAddUserModal:(state,action) => {
        state.addUserModal = action.payload
      },
      closeAddUserModal: (state) => {
        state.addUserModal = {open:false,content:''}
      },
      setErrorState:(state,action) => {
        state.errorState = action.payload
      }
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const {getRoles, openSidebar, closeSidebar, darkMode, openApprovalModal, closeApprovalModal, openAddUserModal, closeAddUserModal,approvalModalLoading, openInlineApprovalModal, closeInlineApprovalModal, setErrorState } = generalSlice.actions
  
  export default generalSlice.reducer